import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=a2c075be&scoped=true&"
import script from "./BlogList.vue?vue&type=script&lang=js&"
export * from "./BlogList.vue?vue&type=script&lang=js&"
import style0 from "./BlogList.vue?vue&type=style&index=0&id=a2c075be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c075be",
  null
  
)

export default component.exports